if (!customElements.get('card-quick-add')) {
  class CardQuickAdd extends HTMLElement {
    constructor() {
      super();

      const url = new URL(this.dataset.productUrl.startsWith('/') ? window.location.origin + this.dataset.productUrl : this.dataset.productUrl);
      const params = url.searchParams;
      params.set('view', 'card-quick-add');
      url.search = params.toString();

      this.productUrl = url;
      this.bindOnBodyClick = this.onBodyClick.bind(this);

      this.productInfo = this.querySelector('product-info');
      this.restockButton = this.querySelector('.restock-custom-button');
      this.restockJson = this.querySelector('.restock-json')
      if (this.restockJson) this.restockProductInfo = JSON.parse(this.restockJson.textContent);
      this.bindTriggerRestockModal = this.triggerRestockModal.bind(this)
      if (this.restockButton) this.restockButton.addEventListener('click', this.bindTriggerRestockModal);

      if (typeof window._RestockRocket == 'undefined' && this.restockButton){
        this.classList.add('no-restock');
        if (this.restockButton)  this.restockButton.classList.add('hidden');
      } else {
        this.classList.remove('no-restock');
        if (this.restockButton) this.restockButton.classList.remove('hidden');
      }
    }

    disconnectedCallback() {
      document.body.removeEventListener('click', this.bindOnBodyClick);
    }

    show(trigger) {
      if (!this.productUrl) return;
      this.openTrigger = trigger;
      const otherCardQuickAdds = document.querySelectorAll('card-quick-add[open]');
      otherCardQuickAdds.forEach(other => {
        if (other != this) {
          other.hide();
        }
      })
      trigger.setAttribute('aria-disabled', true);
      trigger.classList.add('loading');
      trigger.querySelector('.loading__spinner').classList.remove('hidden');

      if (this.restockButton) this.restockButton.removeEventListener('click', this.bindTriggerRestockModal)

      fetch(this.productUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productQuickAdd = responseHTML.querySelector('.section--product-card-quick-add');

          this.removeDOMElements();
          this.preventDuplicatedIDs();
          setTimeout(() => {
            this.setInnerHTML(this.productQuickAdd);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.preventVariantURLSwitching();
          })

        })
        .finally(() => {
          document.body.addEventListener('click', this.bindOnBodyClick);
          this.setAttribute('open', true);
          setTimeout(() => {
            trigger.removeAttribute('aria-disabled');
            trigger.classList.remove('loading');
            trigger.querySelector('.loading__spinner').classList.add('hidden');

            this.productInfo = this.querySelector('product-info');
            this.restockButton = this.querySelector('.restock-custom-button');
            this.restockJson = this.querySelector('.restock-json');
            if (this.restockJson) this.restockProductInfo = JSON.parse(this.restockJson.textContent);
            if (this.restockButton) this.restockButton.addEventListener('click', this.bindTriggerRestockModal);

            if (typeof window._RestockRocket == 'undefined' && this.restockButton){
              this.classList.add('no-restock');
              if (this.restockButton) this.restockButton.classList.add('hidden');
            } else {
              this.classList.remove('no-restock');
              if (this.restockButton) this.restockButton.classList.remove('hidden');
            }

          }, 300)
        });
    }

    hide(trigger) {
      if (trigger) {
        trigger.setAttribute('aria-disabled', true);
        trigger.classList.add('loading');
        trigger.querySelector('.loading__spinner').classList.remove('hidden');
      }

      this.removeAttribute('open');
      document.body.removeEventListener('click', this.bindOnBodyClick);

      setTimeout(() => {
        this.innerHTML = '';
        if (trigger) {
          trigger.removeAttribute('aria-disabled');
          trigger.classList.remove('loading');
          trigger.querySelector('.loading__spinner').classList.add('hidden');
        }

      }, 300)

    }

    setInnerHTML(html) {
      const htmlCardQuickAdd = html.querySelector('card-quick-add')

      this.innerHTML = htmlCardQuickAdd.innerHTML;
      this.classList = htmlCardQuickAdd.classList;

      this.dataset.selectedVariant = htmlCardQuickAdd.dataset.selectedVariant;
      if (htmlCardQuickAdd.hasAttribute('direct-add')) this.setAttribute('direct-add', true)
      if (htmlCardQuickAdd.hasAttribute('notify-on-variant')) this.setAttribute('notify-on-variant', true)


      Array.from(html.querySelectorAll('script')).filter(tag => !tag.classList.contains('klaviyo-skip-script')).forEach(scriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(scriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(scriptTag.innerHTML));
        this.parentElement.appendChild(newScriptTag);
      })
    }

    removeDOMElements() {
      const previewTitle = this.productQuickAdd.querySelector('.preview-title');
      if (previewTitle) previewTitle.remove();

      this.productQuickAdd.querySelector('card-quick-add').classList.remove('preview-size')
    }

    preventVariantURLSwitching() {
      const variantPicker = this.productQuickAdd.querySelector('variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    preventDuplicatedIDs() {
      const sectionId = this.productQuickAdd.querySelector('card-quick-add').dataset.section;
      this.productQuickAdd.innerHTML = this.productQuickAdd.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productQuickAdd.querySelectorAll('variant-selects, product-info').forEach((element) => {
        if (sectionId != undefined)
          element.dataset.originalSection = sectionId;
      });
    }

    triggerRestockModal(event) {
      if (typeof window._RestockRocket == 'undefined') return;

      window._RestockRocket.openModal(this.restockProductInfo, +this.productInfo.dataset.selectedVariant);
    }

    onBodyClick(event) {
      if (!event.target.closest(`#${this.id}`)) {
        this.hide(this.openTrigger)
      }
    }
  }

  customElements.define('card-quick-add', CardQuickAdd)
}


if (!customElements.get('card-quick-add-opener')) {
  class CardQuickAddOpener extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.popupWrapper = document.querySelector(this.dataset.popup);

      if (!this.button || !this.popupWrapper) return;

      this.popup = this.popupWrapper.querySelector('card-quick-add');

      if (!this.popup) return;


      this.button.addEventListener('click', this.onClick.bind(this))
    }

    onClick() {
      if (this.popup.hasAttribute('open')) this.popup.hide(this.button)
      else this.popup.show(this.button)
    }
  }

  customElements.define('card-quick-add-opener', CardQuickAddOpener)
}